import * as React from 'react';
import { InView } from 'react-intersection-observer';
import { FormattedMessage } from 'react-intl';

import { RCComposer } from '@notino/react-rich-content';
import { IComposerData } from '@notino/react-rich-content/dist/types/components/RCComposer/model';
import { GetRichContentForReviewsPageQuery } from '@notino/shared/definitions/types';

import { RICH_CONTENT_SECTION_ID } from '../constants';
import { messages } from '../Header/messages';
import { useReviewsPageStore } from '../store';

import { Section, Title } from './styled';
import '@notino/react-rich-content/dist/react-rich-content.css';

type Props = {
  data: GetRichContentForReviewsPageQuery;
};

export const RichContentSection = ({ data }: Props) => {
  if (
    !data ||
    !data.RichContentByCatalogMasterId?.isAvailable ||
    !data.RichContentByCatalogMasterId?.content
  ) {
    return null;
  }
  return (
    <InView
      onChange={(inView) =>
        useReviewsPageStore.setState({ isRichContentInView: inView })
      }
    >
      <Section id={RICH_CONTENT_SECTION_ID}>
        <Title>
          <FormattedMessage {...messages.rcButton} />
        </Title>
        <RCComposer
          data={tryGetData(data)}
          render={({ rcComponent, error }) => !error && rcComponent}
        />
      </Section>
    </InView>
  );
};

// if for ssr errorPolicy on query is to ignored, try parse data safely
const tryGetData = (data: GetRichContentForReviewsPageQuery): IComposerData => {
  try {
    return {
      rich: data.RichContentByCatalogMasterId.content,
      name: '',
    };
  } catch (e) {
    return { rich: { components: [] }, name: '' };
  }
};
